import React, { Component } from 'react';
import ReactTable from 'Common/ReactTableWrapper';
import { Field } from 'redux-form';
import { get, groupBy, pickBy } from 'lodash';

import { TitledCard, YesNoDialog } from 'Components/';
import { InputField } from 'Common/SemanticWrapper';
import { StatusEnum } from 'Common/Constants/Enumeration/StatusEnum';
import { EditCellModal } from './EditCellModal';

import {
  StatusNames,
  SalesMealTypesEnum,
  InputTypes,
  totalReducer,
} from '../../helpers/EditDailyDepositHelpers';
import {
  EditDailyDepositSalesFieldEnum as Fields,
  EditDailyDepositFieldEnum,
} from 'Common/FieldEnum';
import { MealTypesEnum } from 'Common/Constants/Enumeration/MealTypesEnum';

export class DailyDepositSalesTable extends Component {
  state = {
    freeSalesValueDialog: null,
    editCellModal: null,
    initialTableData: null,
  };

  openEditCellModal = (state, rowInfo, column) => {
    const { disabled, change } = this.props;

    if (disabled) {
      return;
    }

    const prefix = column.id.slice(0, 1);

    const modalCallback = values => {
      change(`${EditDailyDepositFieldEnum.Sales}.${rowInfo.original.Index}`, {
        ...rowInfo.original,
        ...values,
      });

      this.setState({
        editCellModal: null,
      });
    };

    this.setState({
      editCellModal: {
        isFreeStudent: String(rowInfo.original.Status) === StatusEnum.Free,
        prefix,
        statusId: rowInfo.original.Status,
        isMeals: SalesMealTypesEnum.Meals === rowInfo.original.TypeOfMeal,
        initialValues: pickBy(
          rowInfo.original,
          (val, key) => key.slice(0, 1) === prefix
        ),
        okCallback: modalCallback,
        cancelCallback: () =>
          this.setState({
            editCellModal: null,
          }),
      },
    });
  };

  handleInputBlur = async (reduxFormPrefix, inputType, original, newValue) => {
    const { change } = this.props;

    // When a Free Student sales value is set to greater than 0 show a popup asking if they are sure they want to make the change.
    if (
      String(original.Status) === StatusEnum.Free &&
      inputType === InputTypes.Sales &&
      newValue > 0
    ) {
      try {
        await this.showFreeSalesValueChangingDialog();
      } catch (error) {
        change(`${reduxFormPrefix}Detail1`, inputType.formatter(0));
        return;
      }
    }

    change(reduxFormPrefix, inputType.formatter(newValue));
    change(`${reduxFormPrefix}Detail1`, inputType.formatter(newValue));
  };

  getCellContents = ({ column, row, original }) => {
    const inputType = InputTypes[column.id.slice(1)];
    const reduxFormPrefix = `${EditDailyDepositFieldEnum.Sales}[${
      original.Index
    }].${column.id}`;

    //If it isMeals and Column: Supper or Other then use the direct edit field rather than the modal.
    if (
      SalesMealTypesEnum.Meals === original.TypeOfMeal &&
      [MealTypesEnum.Supper, MealTypesEnum.Other].some(
        t => t === column.id.slice(0, 1)
      )
    ) {
      return (
        <Field
          label={false}
          component={InputField}
          name={`${reduxFormPrefix}Detail1`}
          hideError
          mode={inputType.mode}
          numericSize={[8, 2]}
          formatOnBlur={inputType.formatter}
          handleBlur={(e, value) =>
            this.handleInputBlur(reduxFormPrefix, inputType, original, value)
          }
          disabled={this.props.disabled}
        />
      );
    }

    return row[column.id];
  };

  showFreeSalesValueChangingDialog = () => {
    return new Promise((resolve, reject) => {
      this.setState({
        freeSalesValueDialog: {
          yesCallback: () => {
            resolve();
            this.setState({ freeSalesValueDialog: null });
          },
          noCallback: () => {
            reject();
            this.setState({ freeSalesValueDialog: null });
          },
        },
      });
    });
  };

  columns = (isSupper, isMeals, isTotal = false) =>
    [
      {
        Header: '',
        columns: [
          {
            Header: isMeals ? 'Meals' : 'Supplemental Sales',
            id: Fields.Status,
            accessor: row => StatusNames[row[Fields.Status]],
            Footer: isTotal
              ? `Total ${isMeals ? 'Meals' : 'Supplemental Sales'}:`
              : 'Total:',
          },
        ],
      },
    ].concat(
      isSupper
        ? [
            {
              Header: 'Supper',
              columns: [
                {
                  Header: 'Qty.',
                  accessor: Fields.SQty,
                  Cell: this.getCellContents,

                  getProps: () => ({
                    className: 'react-table-highlight-cell',
                  }),
                  Footer: totalReducer(InputTypes.Qty),
                  width: 90,
                },
                {
                  Header: 'Sales',
                  accessor: Fields.SSales,
                  Cell: this.getCellContents,

                  getProps: () => ({
                    className: 'react-table-highlight-cell',
                  }),
                  Footer: totalReducer(InputTypes.Sales),
                  width: 90,
                },
              ],
            },
          ]
        : [
            {
              Header: 'Breakfast',
              columns: [
                {
                  Header: 'Qty.',
                  accessor: Fields.BQty,
                  Cell: this.getCellContents,
                  getProps: () => ({
                    className: 'react-table-highlight-cell',
                  }),
                  Footer: totalReducer(InputTypes.Qty),
                  width: 90,
                },
                {
                  Header: 'Sales',
                  accessor: Fields.BSales,
                  Cell: this.getCellContents,
                  getProps: () => ({
                    className: 'react-table-highlight-cell',
                  }),
                  Footer: totalReducer(InputTypes.Sales),
                  width: 90,
                },
              ],
            },
            {
              Header: 'Lunch',
              columns: [
                {
                  Header: 'Qty.',
                  accessor: Fields.LQty,
                  Cell: this.getCellContents,
                  getProps: () => ({
                    className: 'react-table-highlight-cell',
                  }),
                  Footer: totalReducer(InputTypes.Qty),
                  width: 90,
                },
                {
                  Header: 'Sales',
                  accessor: Fields.LSales,
                  Cell: this.getCellContents,
                  getProps: () => ({
                    className: 'react-table-highlight-cell',
                  }),
                  Footer: totalReducer(InputTypes.Sales),
                  width: 90,
                },
              ],
            },
            {
              Header: 'Other',
              columns: [
                {
                  Header: 'Qty.',
                  accessor: Fields.OQty,
                  Cell: this.getCellContents,
                  getProps: () => ({
                    className: 'react-table-highlight-cell',
                  }),
                  Footer: totalReducer(InputTypes.Qty),
                  width: 90,
                },
                {
                  Header: 'Sales',
                  accessor: Fields.OSales,
                  Cell: this.getCellContents,
                  getProps: () => ({
                    className: 'react-table-highlight-cell',
                  }),
                  Footer: totalReducer(InputTypes.Sales),
                  width: 90,
                },
              ],
            },
          ]
    );

  render() {
    const { isSupper, formValues } = this.props;
    const { freeSalesValueDialog, editCellModal } = this.state;

    let tableData = formValues[EditDailyDepositFieldEnum.Sales].map(
      (i, index) => ({ Index: index, ...i })
    );
    tableData = {
      student: groupBy(
        tableData.filter(r => Number(r[Fields.StatusMerger]) === 1),
        Fields.TypeOfMeal
      ),
      staff: groupBy(
        tableData.filter(r => Number(r[Fields.StatusMerger]) === 2),
        Fields.TypeOfMeal
      ),
      all: groupBy(tableData, Fields.TypeOfMeal),
    };

    const commonProps = {
      loading: this.props.loading,
      className: 'm-t-0 m-b-0',
      getNoDataProps: () => ({ style: { display: 'none' } }),
      getTdProps: (state, rowInfo, column) => {
        const prefix = column.id.slice(0, 1);
        const tdProps = {};

        if (!rowInfo || column.id === Fields.Status) return {};

        // These cells shouldn't have an onclick listener so return early.
        if (
          SalesMealTypesEnum.Meals === rowInfo.original.TypeOfMeal &&
          [MealTypesEnum.Supper, MealTypesEnum.Other].some(t => t === prefix)
        ) {
          tdProps['style'] = { padding: '0px' };
          return tdProps;
        }

        tdProps['onClick'] = () =>
          this.openEditCellModal(state, rowInfo, column);

        return tdProps;
      },
      getTrProps: () => ({ className: 'no-hover' }),
      getTheadGroupProps: () => ({ style: { display: 'none' } }),
      getTheadProps: () => ({ style: { display: 'none' } }),
      getTfootProps: () => ({ style: { fontWeight: 'bold' } }),
      showPagination: false,
      menu: false,
      filterable: false,
      sortable: false,
      minRows: 0,
    };

    return (
      <React.Fragment>
        {editCellModal && <EditCellModal {...editCellModal} />}

        {freeSalesValueDialog && (
          <YesNoDialog
            showDialog={true}
            title={'Free'}
            question={'Free sales values should always be 0. Are you sure?'}
            yesCallback={get(freeSalesValueDialog, 'yesCallback')}
            noCallback={get(freeSalesValueDialog, 'noCallback')}
          />
        )}

        {tableData && (
          <React.Fragment>
            <TitledCard title={'Meals'}>
              <ReactTable
                columns={this.columns(isSupper, true)}
                data={tableData.student[SalesMealTypesEnum.Meals]}
                {...commonProps}
                getTheadProps={() => ({})}
                getTheadGroupProps={() => ({})}
              />
              <ReactTable
                columns={this.columns(isSupper, true)}
                data={tableData.staff[SalesMealTypesEnum.Meals]}
                {...commonProps}
              />
              <ReactTable
                columns={this.columns(isSupper, true, true)}
                data={tableData.all[SalesMealTypesEnum.Meals]}
                {...commonProps}
                getTrProps={() => ({ style: { display: 'none' } })}
              />
            </TitledCard>
            <TitledCard title={'Supplemental Sales'}>
              <ReactTable
                columns={this.columns(isSupper, false)}
                data={tableData.student[SalesMealTypesEnum.Supplemental]}
                {...commonProps}
                getTheadGroupProps={() => ({})}
                getTheadProps={() => ({})}
              />
              <ReactTable
                columns={this.columns(isSupper, false)}
                data={tableData.staff[SalesMealTypesEnum.Supplemental]}
                {...commonProps}
              />
              <ReactTable
                columns={this.columns(isSupper, false, true)}
                data={tableData.all[SalesMealTypesEnum.Supplemental]}
                {...commonProps}
                getTrProps={() => ({ style: { display: 'none' } })}
              />
            </TitledCard>
          </React.Fragment>
        )}
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/modifydailydeposits/components/sales/DailyDepositSalesTable.js